import type { Locale } from 'date-fns'
import {
	BehaviorSubject,
	distinctUntilChanged,
	filter,
	map,
	Subject,
	tap,
} from 'rxjs'

export class CommonLanguageBridge {
	protected static readonly languageChangedSubject = new Subject<void>()
	protected static readonly defaultLanguageSubject =
		new BehaviorSubject<string>('English')
	static readonly defaultLanguage$ = this.defaultLanguageSubject.asObservable()
	static readonly languageChanged$ = this.languageChangedSubject
		.asObservable()
		.pipe(map(() => this.language)) // overridden
	protected static dateLocales: Record<string, Locale> = {}

	static get defaultLanguage() {
		return this.defaultLanguageSubject.value
	}
	static set defaultLanguage(defaultLanguage: string) {
		if (defaultLanguage == this.defaultLanguageSubject.value) return
		this.defaultLanguageSubject.next(defaultLanguage)
		this.languageChangedSubject.next()
	}
	static get languageIsoCode() {
		return ''
	} // overridden

	static θsetDateLocales(dateLocales: Record<string, Locale>) {
		Object.assign(this.dateLocales, dateLocales)
	}

	static get dateLocale() {
		return new Proxy<Locale>({} as any, {
			get: (target, p, receiver) => {
				const lang = this.languageIsoCode?.replaceAll('-', '')
				const defaultLang = this.defaultLanguage?.replaceAll('-', '')
				const locale =
					this.dateLocales[lang] ??
					this.dateLocales[defaultLang] ??
					this.dateLocales['enUS']
				return Reflect.get(locale, p, receiver)
			},
		})
	}

	static get language() {
		return ''
	} // overridden
	static set language(language: string) {} // overridden
}
